/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { xiangmumingcheng, renwuyuedu } from '@/api/searchTypes.js';
export default [
  xiangmumingcheng,
  renwuyuedu,
  {
    id: 'xiangmucanyuren',
    key: 'fullName',
    width: 180,
    tip: '项目参与人',
    label: '项目参与人',
    slot: 'input'
  },
  {
    id: 'shoujihao',
    key: 'phone',
    width: 180,
    tip: '手机号',
    label: '手机号',
    slot: 'input'
  },
  {
    width: 180,
    tip: '订单编号',
    label: '订单编号',
    key: 'orderNo',
    id: 'orderNo',
    slot: 'input'
  },
  {
    width: 140,
    id: 'createDate',
    label: '提交日期',
    required: false,
    slot: 'daterange',
    format: 'yyyy-MM-dd',
    key: 'createDate',
    text: ['提交日期起', '提交日期止']
    // key: ['createDateStart', 'createDateEnd']
  }
];
